import React from "react";

export const ChatSuggestionCard = ({ text, onAccept, onSkip }) => (
  <div
    className="rounded-lg p-3 flex items-start gap-3"
    style={{
      background: "rgba(243,177,74,0.08)",
      border: "1px solid rgba(243,177,74,0.45)",
    }}
    data-testid="ai-chat-suggestion-card"
  >
    <div
      style={{
        fontSize: 16,
        lineHeight: 1,
        color: "#f3b14a",
        flexShrink: 0,
        marginTop: 2,
      }}
    >
      💡
    </div>
    <div className="flex-1">
      <div
        style={{
          fontFamily: "'DM Mono', monospace",
          fontSize: 12,
          color: "#f0d8a0",
          lineHeight: 1.5,
        }}
        data-testid="ai-chat-suggestion-text"
      >
        {text}
      </div>
      <div className="flex gap-2 mt-2">
        <button
          onClick={onAccept}
          className="px-3 py-1.5 rounded"
          style={{
            background: "rgba(78,208,132,0.15)",
            border: "1px solid #4ed084",
            color: "#4ed084",
            fontFamily: "Syne, sans-serif",
            fontWeight: 600,
            fontSize: 11,
            letterSpacing: "0.4px",
            cursor: "pointer",
          }}
          data-testid="ai-chat-suggestion-accept"
        >
          ✓ Yes, add it
        </button>
        <button
          onClick={onSkip}
          className="px-3 py-1.5 rounded"
          style={{
            background: "transparent",
            border: "1px solid rgba(255,255,255,0.10)",
            color: "#9198b0",
            fontFamily: "'DM Mono', monospace",
            fontSize: 11,
            letterSpacing: "0.4px",
            cursor: "pointer",
          }}
          data-testid="ai-chat-suggestion-skip"
        >
          Skip
        </button>
      </div>
    </div>
  </div>
);

